import { render, staticRenderFns } from "./PersonCourses.vue?vue&type=template&id=5361099e"
import script from "./PersonCourses.vue?vue&type=script&lang=js"
export * from "./PersonCourses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports